const TestimonialsData = [
  {
    quote: 'Mycket trevligt bemötande från personal som hämtar kärlen hos oss, alltid hjälpsam!',
    name: 'Inköpsansvarig',
    position: 'Stockholm',
  },
  {
    quote: 'Snabb service när man beställer extrahämtning och bra kontakt med säljarna',
    name: 'Office Manager',
    position: 'Göteborg',
  },
  {
    quote: 'Er kundsupport är jättebra! Lätt och smidigt att boka eller avboka hämtningar.',
    name: 'Receptionist',
    position: 'Stockholm',
  },
];

export default TestimonialsData;
